import React, { useEffect, useState, useMemo } from "react";
import { useController } from "react-hook-form";
import {
  StyledControls,
  StyledOptionGroups,
} from "./supplementalSubmissionFields.style";
import Field, {
  TYPES,
} from "../../../../formComponents/formFields/field.component";

const OptionGroup = ({ required, name, ...props }) => {
  const newItem = useMemo(
    () => Object.entries(JSON.parse(props.default))[0],
    [props],
  );
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    rules: { required: { value: required, message: "This field is required" } },
  });

  const getInitialValue = () => {
    try {
      return Object.entries(JSON.parse(field.value)).map(([key, value]) => ({
        label: key,
        options: value,
      }));
    } catch (error) {
      return [{ label: "", options: field.value }];
    }
  };
  const [options, setOptions] = useState(getInitialValue());

  const handleChangeLabel = (idx, value) => {
    const newOptions = [...options];
    const item = { ...newOptions[idx] };
    item.label = value;
    newOptions[idx] = item;
    setOptions(newOptions);
  };

  const handleChangeOptions = (idx, value) => {
    const newOptions = [...options];
    const item = { ...newOptions[idx] };
    item.options = value;
    newOptions[idx] = item;
    setOptions(newOptions);
  };

  useEffect(() => {
    if (!options.length) {
      field.onChange(null);
      return;
    }
    const transformed = options.reduce((acc, item) => {
      if (item.options === "" && item.label === "") return acc;
      acc[item.label] = item.options;
      return acc;
    }, {});
    field.onChange(JSON.stringify(transformed));
  }, [options, field]);

  const handleRemove = (e, index) => {
    e.preventDefault();
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const handleAddField = (e) => {
    e.preventDefault();
    const newOptions = [...options];
    newOptions.push({ label: newItem[0], options: newItem[1] });
    setOptions(newOptions);
  };

  const lastIndex = options.length - 1;
  return (
    <StyledOptionGroups>
      <div>
        {options.map((item, index) => (
          <div key={index}>
            <Field
              type={TYPES.SIMPLE_TEXT}
              value={item.label}
              onChange={(e) => handleChangeLabel(index, e.target.value)}
              externalLabel="Label"
              required={false}
              name={`option_group_label_${index}`}
              useInForm={false}
            />
            <Field
              type={TYPES.SIMPLE_TEXTAREA}
              value={item.options}
              onChange={(e) => handleChangeOptions(index, e.target.value)}
              externalLabel="Options"
              required={false}
              name={`option_group_options_${index}`}
              useInForm={false}
            />

            <StyledControls>
              <a href="#" onClick={(e) => handleRemove(e, index)}>
                – Remove option group
              </a>
              {index === lastIndex && (
                <a href="#" onClick={handleAddField}>
                  + Add another option group
                </a>
              )}
            </StyledControls>
            {index !== lastIndex && <hr />}
          </div>
        ))}
      </div>
      <span className="error">{error?.message || ""}</span>
      {lastIndex === -1 && (
        <StyledControls>
          <a href="#" onClick={handleAddField}>
            + Add option group
          </a>
        </StyledControls>
      )}
    </StyledOptionGroups>
  );
};

export default OptionGroup;
